<template>
  <div class="play-item">
    <img
      class="small"
      :src="
        activeKey.indexOf('supback') > -1
          ? srctree['supback'].asrc
          : srctree['supback'].src
      "
      @click="toplay('supback', 4)"
    />
    <img
      class="medium"
      :src="
        activeKey.indexOf('back') > -1
          ? srctree['back'].asrc
          : srctree['back'].src
      "
      @click="toplay('back', 2)"
    />
    <img
      class="big"
      :src="
        activeKey.indexOf('play') > -1
          ? srctree['play'].asrc
          : srctree['play'].src
      "
      @click="toplay('play', 1)"
    />
    <img
      class="medium"
      :src="
        activeKey.indexOf('speed') > -1
          ? srctree['speed'].asrc
          : srctree['speed'].src
      "
      @click="toplay('speed', 2)"
    />
    <img
      class="small"
      :src="
        activeKey.indexOf('supspeed') > -1
          ? srctree['supspeed'].asrc
          : srctree['supspeed'].src
      "
      @click="toplay('supspeed', 4)"
    />
  </div>
</template>

<script>
export default {
  name: "playBox",
  props:['mapData','btnIndex'],
  data() {
    return {
      srctree: {
        supback: {
          src: require("../assets/sup-back.png"),
          asrc: require("../assets/sup-back-sd.png")
        },
        back: {
          src: require("../assets/back.png"),
          asrc: require("../assets/back-sd.png")
        },
        play: {
          src: require("../assets/stop.png"),
          asrc: require("../assets/play.png")
        },
        speed: {
          src: require("../assets/speed.png"),
          asrc: require("../assets/speed-sd.png")
        },
        supspeed: {
          src: require("../assets/sup-speed.png"),
          asrc: require("../assets/sup-speed-sd.png")
        }
      },
      activeKey: [],
      btnindex:this.btnIndex,
      currInterval:''
    };
  },
  watch:{
    btnIndex(v){
      this.btnindex = v
    }
  },
  methods: {
    // 创建功能定时器
    toplay(key, rate) {
      // 小于2张图片禁止播放
      if (this.mapData.length <= 1) {
        this.pauseing();
        return;
      }
      // 暂停
      if(this.activeKey.indexOf(key)>-1 && key === 'play'){
        this.pauseing()
        return;
      }
      // 其他播放
      if(key!=='play'){
        this.pauseing()
        this.activeKey.push('play')
      }
      // 播放或更改其他播放
      this.activeKey.push(key)
      let that = this;
      // 执行功能
      let _intr = setInterval(() => {
        console.log(`[播放组件]${key}=>btnindex:`, this.btnindex);
        switch (key) {
          case "play":
          case "speed":
          case "supspeed":
            if (that.btnindex == that.mapData.length - 1) {
              that.pauseing();
            } else {
              that.btnindex = that.btnindex < that.mapData.length - 1 ? that.btnindex + 1 : that.mapData.length - 1;
            }
            break;
          case "back":
          case "supback":
            if (that.btnindex == 0) {
              that.pauseing();
            } else {
              that.btnindex = that.btnindex > 0 ? that.btnindex - 1 : 0;
            }
            break;
        }
        // 同步父组件缩略图下标
        that.$emit('changeIndex',that.btnindex)
      }, 2000/rate);
      this.currInterval = _intr;
    },
    // 清除功能定时器
    pauseing(){
      window.clearInterval(this.currInterval);
      this.currInterval = ''
      this.activeKey=[]
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/index";
.play-item {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  width: 100%;
  .big {
    height: px2rem(80);
    width: px2rem(80);
  }
  .medium {
    height: px2rem(75);
    width: px2rem(75);
  }
  .small {
    height: px2rem(30);
    width: px2rem(30);
  }
  /*border: 1px solid violet;*/
}
</style>
